// Nicaragua: 15 departamentos + 2 regiones autónomas (nivel 1) + municipios (nivel 2).
// El nivel 2 incluye cabeceras/ciudades principales como seed;
// el catálogo municipal completo (153) se carga desde INIDE antes del go-live.
export const geoDataNI = {
    departments: [
        { id: 0, name: "Seleccione Departamento" },
        { id: 1, name: "Boaco" },
        { id: 2, name: "Carazo" },
        { id: 3, name: "Chinandega" },
        { id: 4, name: "Chontales" },
        { id: 5, name: "Estelí" },
        { id: 6, name: "Granada" },
        { id: 7, name: "Jinotega" },
        { id: 8, name: "León" },
        { id: 9, name: "Madriz" },
        { id: 10, name: "Managua" },
        { id: 11, name: "Masaya" },
        { id: 12, name: "Matagalpa" },
        { id: 13, name: "Nueva Segovia" },
        { id: 14, name: "Río San Juan" },
        { id: 15, name: "Rivas" },
        { id: 16, name: "Costa Caribe Norte" },
        { id: 17, name: "Costa Caribe Sur" }
    ],
    municipalities: [
        { provinceId: 0, id: 0, name: "Seleccione Municipio", code: 0 },
        { provinceId: 1, id: 1, name: "Boaco", code: 101 },
        { provinceId: 2, id: 2, name: "Jinotepe", code: 201 },
        { provinceId: 2, id: 3, name: "Diriamba", code: 202 },
        { provinceId: 3, id: 4, name: "Chinandega", code: 301 },
        { provinceId: 3, id: 5, name: "Corinto", code: 302 },
        { provinceId: 3, id: 6, name: "El Viejo", code: 303 },
        { provinceId: 4, id: 7, name: "Juigalpa", code: 401 },
        { provinceId: 5, id: 8, name: "Estelí", code: 501 },
        { provinceId: 6, id: 9, name: "Granada", code: 601 },
        { provinceId: 7, id: 10, name: "Jinotega", code: 701 },
        { provinceId: 8, id: 11, name: "León", code: 801 },
        { provinceId: 9, id: 12, name: "Somoto", code: 901 },
        { provinceId: 10, id: 13, name: "Managua", code: 1001 },
        { provinceId: 10, id: 14, name: "Ciudad Sandino", code: 1002 },
        { provinceId: 10, id: 15, name: "Tipitapa", code: 1003 },
        { provinceId: 10, id: 16, name: "Ticuantepe", code: 1004 },
        { provinceId: 11, id: 17, name: "Masaya", code: 1101 },
        { provinceId: 11, id: 18, name: "Nindirí", code: 1102 },
        { provinceId: 12, id: 19, name: "Matagalpa", code: 1201 },
        { provinceId: 13, id: 20, name: "Ocotal", code: 1301 },
        { provinceId: 14, id: 21, name: "San Carlos", code: 1401 },
        { provinceId: 15, id: 22, name: "Rivas", code: 1501 },
        { provinceId: 15, id: 23, name: "San Juan del Sur", code: 1502 },
        { provinceId: 16, id: 24, name: "Bilwi (Puerto Cabezas)", code: 1601 },
        { provinceId: 17, id: 25, name: "Bluefields", code: 1701 }
    ]
};
